/* eslint-disable @typescript-eslint/no-explicit-any */
import { PluginFunction } from 'vue';
import { Vue } from 'vue-property-decorator';
import { $delay } from './common/utils/index';

declare interface BasePlugin {
  install: PluginFunction<any>;
}

const plugin: BasePlugin = {
  install(v: typeof Vue) {
    v.prototype.$delay = $delay;
  },
};

export default plugin;
